var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    height: 15,
    width: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7,6.8c-0.2-0.2-0.4-0.3-0.7-0.3H2.9l3.4-4.6c0.2-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.5-0.3-0.7 C6,0.2,5.8,0.1,5.5,0.2c-0.2,0-0.5,0.2-0.6,0.4L0.2,6.8c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.1C0,7.2,0,7.4,0,7.5 c0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2l4.7,6.3c0.1,0.1,0.2,0.2,0.3,0.3s0.3,0.1,0.4,0.1 c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.3-0.2-0.4L2.9,8.5h11.1 c0.2,0,0.5-0.1,0.7-0.3C14.9,8,15,7.8,15,7.5C15,7.2,14.9,7,14.7,6.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.75d5253e.svg";
export { ForwardRef as ReactComponent };